export enum Types {
	ENVIA_CENTRAL_LIBERACAO = '@aac/ENVIA_CENTRAL_LIBERACAO',
	ENVIA_CENTRAL_LIBERACAO_SUCCESS = '@aac/ENVIA_CENTRAL_LIBERACAO_SUCCESS',
	ENVIA_CENTRAL_LIBERACAO_FAILURE = '@aac/ENVIA_CENTRAL_LIBERACAO_FAILURE',
	ENVIA_CENTRAL_LIBERACAO_CLEAR = '@aac/ENVIA_CENTRAL_LIBERACAO_CLEAR',
}

export interface CentralLiberacao {
	status: number;
	resultado: EnviaCentralLiberacao | null;
}

export interface EnviaCentralLiberacao {
	atestadoEmitido: boolean;
	codigoRetorno: string;
	mensagemRetorno: string;
	dataEmissaoAtestado: string;
	codigoValidacao: string;
	id: string;
}

export interface EnviaCentralLiberacaoRequest {
	usuario?: string;
	codigoRetorno: string;
	numeroRg: string;
	nome: string;
	nomeSocial: string;
	nomePai: string;
	nomeMae: string;
	sexo: string;
	dataNascimento: string;
	posto: string;
	ipEstacao: string;
	dataExpedicaoRg: string;
	tipoDocApresentado: string;
	nomeProcurador: string;
	status: string;
	docProcurador: string;
	tipoEncaminhamento: string;
	origem: string;
	dc: string;
	tipoRestricao: string;
	dcCpf: string;
	cpf: string;
}
